/**
 * @fileoverview Outcomes Outreach API Module
 * This module provides API functions for managing outcomes outreach.
 */

import api from "./api";

/**
 * Fetch outcomes outreach data
 * @async
 * @function getOutcomesOutreach
 * @param {Object} [params] - Optional query parameters
 * @returns {Promise<Object>} Promise resolving to the outcomes outreach data
 * @throws {Error} Throws error if API request fails
 */
let outcomesOutreachPromise = null;
let outcomesOutreachCache = null;

export const getOutcomesOutreach = async (params = {}) => {
  const hasParams = Object.keys(params).length > 0;
  if (!hasParams && outcomesOutreachCache) {
    return outcomesOutreachCache;
  }
  if (!hasParams && outcomesOutreachPromise) {
    return outcomesOutreachPromise;
  }

  const fetchPromise = (async () => {
    try {
      const response = await api.get("/api/outcomes-outreach", {
        params,
        headers: {
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true",
        },
      });
      if (!hasParams) {
        outcomesOutreachCache = response.data;
      }
      return response.data;
    } catch (e) {
      throw new Error(`getOutcomesOutreach failed: ${e.message}`);
    } finally {
      if (!hasParams) {
        outcomesOutreachPromise = null;
      }
    }
  })();

  if (!hasParams) {
    outcomesOutreachPromise = fetchPromise;
  }
  return fetchPromise;
};

export const clearOutcomesOutreachCache = () => {
  outcomesOutreachCache = null;
  outcomesOutreachPromise = null;
};
